import axiosInstance from '../axios.instance';

export const getAllProductsApi = (params) => axiosInstance
  .get('/product/all', {
    params,
  });

export const getCurrentProductApi = (productLink, params, token = null, headers) => (axiosInstance.get(`/product/get/${productLink}`,
  {
    params,
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
      ...headers,
    },
  }));

export const getCurrentUserProductApi = (productLink, token) => axiosInstance.get(`/product/user/${productLink}`,
  {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

export const getSimilarProductsApi = (productLink) => axiosInstance.get(`/product/similar/${productLink}`);

export const uploadImageWithProgress = (data, token, size, length, setProgress, i) => axiosInstance.post('/product/upload', data, {
  onUploadProgress: (progressEvent) => {
    const temp = [];
    if (Math.round((progressEvent.loaded / size) * 100) > 100) {
      temp[i] = 100;
    } else {
      temp[i] = Math.round((progressEvent.loaded / size) * 100);
    }
    for (let k = 0; k < length; k += 1) {
      if (k < i) {
        temp[k] = 100;
      } else if (k > i) {
        temp[k] = 0;
      }
    }

    setProgress(temp);
  },
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${token}`,
  },
});

export const uploadImage = (data, token) => axiosInstance.post('/product/upload', data, {
  headers: {
    'Content-Type': 'multipart/form-data',
    Authorization: `Bearer ${token}`,
  },
});

export const createProductApi = (data, token) => axiosInstance.post('/product/create', data, {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});

export const getUserProductsApi = (params, token) => axiosInstance
  .get('/product/user', { params, headers: { Authorization: `Bearer ${token}` } });

export const updateUserProductStatusApi = (params, token) => axiosInstance
  .post(`/product/status-update/${params.link}`, null, {
    headers: { Authorization: `Bearer ${token}` },
  });

export const deleteUserProductApi = (params, token) => axiosInstance
  .delete(`/product/delete/${params.link}`, { headers: { Authorization: `Bearer ${token}` } });

export const editUserProductApi = (data, link, token) => axiosInstance
  .post(`/product/update/${link}`, data, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

export const sendProductComplaintApi = (message, token) => axiosInstance.post('/product/create-complaint', message,
  token && {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
  });

export const removeImgApi = (id, token) => axiosInstance.delete(`/product/delete-photo/${id}`, {
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${token}`,
  },
});
